import React, { ReactElement, useState } from 'react';
import './Thanks.scss';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import Loading from '../../components/loading/Loading';
import axios from 'axios';

const Thanks: React.FC = (): ReactElement => {
  type ValidationErrors = {
    Receiver: { state: boolean; message: string };
    Title: { state: boolean; message: string };
  };
  const location = useLocation();
  const { t } = useTranslation();
  const [loading, setLoading] = useState<boolean>(false);
  const submittedImg = location.state.image;
  // const [submittedImg, setSubmittedImg] = useState<string>(
  //   location.state.image
  // );

  const [errors, setValidationErrors] = useState<ValidationErrors>({
    Receiver: { state: false, message: '' },
    Title: { state: false, message: '' },
  });
  const submitForm = () => {
    setLoading(true);
    const myForm = document.getElementById('email-form') as HTMLFormElement;
    const formData = new FormData(myForm);
    formData.append('image', submittedImg);

    formData.forEach((entries) => console.log(entries));
    axios
      .post('http://192.168.1.81:3002/email', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          /*'Access-Control-Allow-Origin': 'http://localhost:3002',*/
        },
      })
      //.post('http://192.168.1.81:3002/upload', {headers: {"Access-Control-Allow-Origin": "http://192.168.1.81:3002"}})
      .then((res) => {
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  return (
    <div className="Thanks">
      <Loading loading={loading} />

      <Link to="/" className="close-button">
        <FontAwesomeIcon icon={faXmark} />
      </Link>
      <img src={submittedImg} alt="" />
      {/* <p>{t('thanks subheader')}</p> */}
      <form onSubmit={submitForm} id="email-form" className="share-container">
        <div>
          <button type="submit" className="button">
            {t('email')}
          </button>
          <a className="button" href={submittedImg} download="kutse">
            {t('download')}
          </a>
        </div>
        <div className="email-fields">
          <div className="field">
            <div className="control">
              <input
                className="input"
                type="email"
                name="receiver"
                placeholder={t('email receiver')}
              />
            </div>
            {/* {errors.Sender.state && (
                    <p className="help is-danger">
                      {t('validation.' + errors.Sender.message)}
                    </p>
                  )} */}
          </div>
          <div className="field">
            <div className="control">
              <input
                className="input"
                type="text"
                name="title"
                placeholder={t('email title')}
              />
            </div>
            {/* {errors.Sender.state && (
                    <p className="help is-danger">
                      {t('validation.' + errors.Sender.message)}
                    </p>
                  )} */}
          </div>
        </div>
      </form>
    </div>
  );
};

export default Thanks;
